/* eslint-disable */
import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del, download, genStandard } = apiFuns;

let api = {
  /** ****************** 用户 ****************** **/
  Server: com.Server,
  User: com.User,
  Oidc: {
    get: (au, openId) => get(`/api/md/staff/oidc/${au}/${openId}`),
    update: (para) => put(`/api/md/staff/oidc/${para.auCode}/${para.openId}`, para),
    add: (userId, para) => post(`/api/md/staff/${userId}/oidc`, para),
    getImg: (para) => get(`/api/md/staff/oidc/signImage`, para),
  },
  /** ****************** 门诊挂号记录 ****************** **/
  getOp: (opNo) => get(`/api/op/reg/no/${opNo}`),
  /** ****************** 住院记录 ****************** **/
  getIp: (ipNo) => get(`/api/ip/hospitalization/ipNo/${ipNo}`),
  /** ****************** 元素 ****************** **/
  Element: genStandard("element", "/api/emr"),
  /** ****************** 获取字典 ****************** **/
  Dict: com.Dict,
  /** ****************** 获取接口实体 ****************** **/
  Api: {
    ...genStandard("api", "/api/emr"),
    exec: (url) => get(`/api${url}`), // 执行
  },
  /** ****************** 模板 ****************** **/
  Tmpl: {
    ...genStandard("tmpl", "/api/emr"),
    lock: (id) => put(`/api/emr/tmpl/${id}/lock`),
    unlock: (id) => del(`/api/emr/tmpl/${id}/lock`),
    copy: (id, para) => post(`/api/emr/tmpl/${id}/copy`, para),
  },
  TmplVer: {
    ...genStandard("tmplVer", "/api/emr"),
    audit: (id, ok, reason) => put(`/api/emr/tmplVer/${id}/audit`, { ok: ok, reason: reason }),
    view: (tmplId) => get(`/api/emr/tmplVer/view/${tmplId}`), // 获取浏览用版本
    edit: (tmplId) => get(`/api/emr/tmplVer/edit/${tmplId}`), // 获取编辑用版本
  },
  /** ****************** 病历 ****************** **/
  MrMain: {
    ...genStandard("main", "/api/emr"),
    lock: (id) => put(`/api/emr/main/${id}/lock`),
    unlock: (id) => del(`/api/emr/main/${id}/lock`),
    submit: (id) => put(`/api/emr/main/${id}/submit`),
    relate: (id, opNo) => put(`/api/emr/main/${id}/relation/${opNo}`),
    unRelate: (id, opNo) => del(`/api/emr/main/${id}/relation/${opNo}`),
    quote: (id, opNo) => put(`/api/emr/main/${id}/quote/${opNo}`),
    md5: (id) => get(`/api/emr/main/${id}/md5s`),
    signImg: (staffId) => get(`/api/md/staff/oidc/signImage?staffId=${staffId}`),
    archive: (id) => put(`/api/emr/main/${id}/archived`),
    unarchive: (id) => del(`/api/emr/main/${id}/archived`),
    forceLock: (id) => put(`/api/emr/main/${id}/forceLock`),
    forceUnlock: (id) => del(`/api/emr/main/${id}/forceLock`),
    text: (id) => get(`/api/emr/main/${id}/text`),
    send: (id, para) => put(`/api/emr/main/${id}/send`, para),
    extract: (id) => put(`/api/emr/main/${id}/extract`),
  },
  /** ****************** 文书 ****************** **/
  Mr: {
    ...genStandard("mr", "/api/emr"),
    lock: (id) => put(`/api/emr/mr/${id}/lock`),
    qcLock: (id) => put(`/api/emr/mr/${id}/qcLock`),
    unlock: (id) => del(`/api/emr/mr/${id}/lock`),
    sign: (para) => put(`/api/emr/mr/sign`, para),
  },
  MrVer: {
    ...genStandard("mrVer", "/api/emr"),
    audit: (para, state) => put(`/api/emr/mrVer/${para.id}/audit/${state}`, para),
    view: (docId) => get(`/api/emr/mrVer/view/${docId}`), // 获取浏览用版本
    edit: (docId) => get(`/api/emr/mrVer/edit/${docId}`), // 获取编辑用版本
    last: (docId) => get(`/api/emr/mrVer/last/${docId}`), // 获取最后版本
  },
  /** ************质控记录**************** **/
  QcLog: {
    ...genStandard("qcLog", "/api/emr"),
    getDefault: (mrMainId) => post(`/api/emr/qcLog/default/${mrMainId}`),
  },
  /** ************质控明细**************** **/
  QcLogDetail: {
    ...genStandard("qcLogDetail", "/api/emr"),
    getDefault: (mainId, mrId) => post(`/api/emr/qcLogDetail/default/${mainId}/${mrId}`),
  },
  /** ************时限质控规则**************** **/
  QcRule: genStandard("qcRule", "/api/emr/"),
  /** ************知识库**************** **/
  Help: {
    ...genStandard("help", "/api/emr"),
    times: (id) => put(`/api/emr/help/${id}/times`),
  },
  /** ****************** 就诊记录 ****************** **/
  Treatment: {
    ...genStandard("opTreatment", "/api/op"),
    sync: (para) => post(`/api/op/opTreatment/sync/hisReg`, para),
  },
  Hospitalization: {
    ...genStandard("hospitalization", "/api/ip"),
  },
  /** ****************** 患者 ****************** **/
  Patient: com.Patient,

  /** ****************** 病历收藏 ****************** **/
  Collection: genStandard("collection", "/api/emr"),

  /** ****************** 结构化数据 ****************** **/
  Struct: {
    query: (tmplCode, para) => get(`/api/emr/structureData/${tmplCode}`, para),
    save: (tmplCode, mrId, para) => put(`/api/emr/structureData/${tmplCode}/${mrId}`, para),
    del: (tmplCode, mrId) => del(`/api/emr/structureData/${tmplCode}/${mrId}`),
    del1: (tmplCode, mrId) => del(`/api/emr/structureData/${tmplCode}/${mrId}/1`),
    repair: (para) => post(`/api/emr/structureData/repair`, para),
  },
  /** ****************** 配置 ****************** **/
  Setting: genStandard("setting", "/api/md", true),
  Attachment: genStandard("attachment", "/api/store"),
};

export default api;
